export const stripeData = {
			//publishableKey : 'pk_test_eoEKFdOekoye24ZmoJdcdwAk'
			publishableKey : 'pk_live_4MulHw2TNC4GpfMobaPyHKAQ'
}